import School from 'linced-app/models/schools/school';

// Proto: schools.School. This file re-exports the schools/school model.
export default School;
